<div class="contenitore-generale bg-app-bar">
  <div class="title">
    <h1 *ngIf="translate.currentLang == 'it'">Avviso</h1>
    <h1 *ngIf="translate.currentLang == 'en'">Notice</h1>
  </div>
  <div class="container">
    <p *ngIf="translate.currentLang == 'it'">L'Email utilizzata è in uso.</p>
    <p *ngIf="translate.currentLang == 'en'">Email Already in Use</p>

    <div class="bottoni">
      <button mat-dialog-close *ngIf="translate.currentLang == 'it'">Chiudi</button>
      <button mat-dialog-close *ngIf="translate.currentLang == 'en'">Close</button>
    </div>
  </div>
</div>
